<template>
	<div>
		<h1>History</h1>
		<!--input type="text" v-model="search_txt" placeholder="Suche..." @keyup.enter="search" class="left_space"-->
		<table>
			<thead>
				<th>Importdatum</th>
				<th>Bezeichnung</th>
				<th>Status</th>
				<th>Typ</th>
				<th></th>
				<th></th>
				<th></th>
				<th></th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in recs" :key="idx">
					<td>{{ rec.imported | recdate }}</td>
					<td>{{ rec.name }}</td>
					<td><span class="badge" :class="rec.status">{{ rec.status |recstatus }}</span></td>
					<td>{{ rec.schema === 'JOURNAL' ? 'Journal' : 'Bankauszug' }}</td>
					<td v-if="$store.state.customer.accounting_tool.substr(0, 7) === 'pesaris'"><i class="fas fa-satellite-dish" title="Übermitteln" @click="submitShowDlg(rec.id)"></i></td>
					<!--td v-if="$store.state.customer.accounting_tool.substr(0, 7) === 'pesaris'"><i class="fas fa-satellite-dish" title="Übermitteln" @click="submitImportData(rec.id)"></i></td-->
					<td v-else><i class="fas fa-download" title="Herunterladen"></i></td>
					<td><a :href="$globals.API_REL_URL + 'protocol.php?iid=' + rec.id" target="_blank" class="anl"><i class="far fa-file-alt" :class="rec.status === 'PENDING' ? 'disabled' : ''" title="Protokoll"></i></a></td>
					<td><i class="fas fa-pencil-alt" title="Bearbeiten" @click="editImportData(rec.id, rec.schema)"></i></td>
					<td><i class="fas fa-trash-alt" title="Löschen" @click="deleteShowDlg(rec.id)"></i></td>
				</tr>
			</tbody>
		</table>

		<modal name="modalSubmit" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Übermittlung bestätigen</div>
			<div class="delConf-content">
				'{{ selected_name }}' wirklich übermitteln?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="submitImportData" class="delConf-btn-del">Ja</button>
				<button @click="$modal.hide('modalSubmit')">Nein</button>
			</div>
		</modal>

		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Import-Daten '{{ selected_name }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			selected_id: '',
			selected_name: '',
			recs: []
		}
	},
    computed: {
		client_id () {
			return this.$store.state.customer.id
		}
	},
    methods: {
		deleteShowDlg: function (rid) {
			this.selected_id = rid
			this.selected_name = ''
			var i
			for(i=0; i<this.recs.length; i++) {
				if (this.recs[i].id === rid) {
					this.selected_name = this.recs[i].name
					break
				}
			}
			this.$modal.show('modalDel')
		},
		deleteRec: function () {
			var vm = this
			vm.apiCall([{method: 'import/delete', param: {id: vm.selected_id}, id: 12},{method: 'import/list', param: {client_id: vm.client_id}, if: [{id: 12, path: 'result/success', eq: true}], id: 10}], this.evalApiResponse)
			this.$modal.hide('modalDel')
		},
		editImportData: function (rid) {
			var vm = this
			vm.apiCall([{method: 'import/load', param: {id: rid}, id: 20}], vm.evalApiResponse)
		},
		submitShowDlg: function (rid) {
			this.selected_id = rid
			this.selected_name = ''
			var i
			for(i=0; i<this.recs.length; i++) {
				if (this.recs[i].id === rid) {
					this.selected_name = this.recs[i].name
					break
				}
			}
			this.$modal.show('modalSubmit')
		},
		submitImportData: function () {
			var vm = this, rid = vm.selected_id
			vm.apiCall([{method: 'import/submit/enter', param: {import_id: rid}, id: 30},{method: 'import/list', param: {client_id: vm.client_id}, if: [{id: 30, path: 'result/success', eq: true}], id: 10}], vm.evalApiResponse)
			this.$modal.hide('modalSubmit')
		},
		populateDT: function () {
			var vm = this
			vm.apiCall([{method: 'import/list', param: {client_id: vm.client_id}, id: 10}], vm.evalApiResponse)
		},
		evalApiResponse: function (resp) {
			var vm = this
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'import/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.recs = value.result
					}
					break
				  case 12: // 12 = Result from 'import/delete'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$snotify.success('Import-Daten gelöscht', 'OK')
					}
					break
				  case 20: // 20 = Result from 'import/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
					//					console.log(value)
						vm.$store.commit('set_import_param', value.result)
						if (value.result.schema === 'JOURNAL') {
							vm.$router.push({ path: '/home/import/journal'})
						} else {
							vm.$router.push({ path: '/home/import/upload'})
						}
					}
					break
				  case 30: // 30 = Result from 'import/submit/enter'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (value.result.hasOwnProperty('incomplete')) vm.$snotify.error('Die Daten wurden übermittelt. Siehe Buchungsprotokoll für Details.', 'ERROR', {timeout: 8000})
						else vm.$snotify.success('Die Daten wurden verbucht', 'OK')
					}
					break
				}
			  }
			})
		}
    },
    filters: {
		recdate: function (val) {
			var a = val.substr(0,10).split('-')
			return a[2] + '.' + a[1] + '.' + a[0]
		},
		recstatus: function (val) {
			switch(val) {
				case 'PENDING': return 'AUSSTEHEND'
				case 'DOWNLOADED': return 'HERUNTERGELADEN'
				case 'SUBMITTED': return 'ÜBERMITTELT'
				default: return ''
			}
		}
    },
    watch: {
		client_id (newVal, oldVal) {
			this.populateDT()
		}
    },
    mounted: function () {
		this.populateDT()
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

tr.approved {background: #a9ffa9}

td > i {
	cursor: pointer;
}

input[type=text], select {
	border: 1px solid #888;
	padding:3px;
	background: #fff;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.DOWNLOADED, .badge.SUBMITTED {
	background: #080;
}

.badge.PENDING {
	background: #f70;
}


/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.disabled {
	cursor: auto;
	color: #aaa;
}

.anl {
	text-decoration: none;
	color: #000;
}
</style>
